<template>
<div class="manuffilter">
Fabricante
<hr>
<Manufacturer v-for="m in manufacturers" :key="m.name" :info="m"/>
</div>
</template>

<script>
import Manufacturer from './Manufacturer.vue';

export default {
	name: 'ManufFilter',
	computed: {
		manufacturers() {
			/* To react to state changes, should not be in data() */
			return this.$store.state.manufacturers;
		}
	},
	components: { Manufacturer }
}
</script>

<style scoped>

div.manuffilter {
	margin-bottom: 2em;
}

div.manuffilter hr {
	margin-top: 0.5em ! important;
}

</style>



// WEBPACK FOOTER //
// src/components/ManufFilter.vue